import React, { useEffect, useState } from "react";
import { getPageData } from "../api/pageService";
import { sleep } from "../utils/sleep";
import { Title, Meta, Link as SeoLink } from "react-head";

import Project from '../components/Projects';

const Projects = () => {
  const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
            const fetchPageData = async () => {
              try {
                // simulate network delay (3 sec)
                //await sleep(3000);
      
                const data = await getPageData("projects"); // asynchronous call
                setPageData(data);
              } catch (err) {
                setError("Failed to load projects page data.");
              } finally {
                setLoading(false);
              }
            };
        
            fetchPageData();
    }, []);
  
  return (
    <>
      <Title>{pageData? pageData.seo.title:''}</Title>
                 <Meta
                   name="description"
                   content={pageData?pageData.seo.description:''}
                 />
      <SeoLink rel="canonical" href={pageData ? pageData.seo.canonical : ''} />
      
      {/* Projects */}
      <Project />
    </>
  );
};

export default Projects;
